import { Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { WinGameFixture, WinGameParticipant } from '@frontend/sports/racing/feature/models';

import { HorsesFixtureParticipantHelper } from '../../../horse-racing-shared/services/horses-fixture-participant-helper.service';

@Component({
    selector: 'ms-race-timeform-spotlight',
    templateUrl: 'race-timeform-spotlight.html',
    standalone: false,
})
export class RaceTimeformSpotlightComponent {
    @Input() set fixture(value: WinGameFixture) {
        this.setViewModel(value);
    }

    timeformSpotlightIndexes: number[] = [];
    timeformTipRunner: WinGameParticipant;
    timeformSpotlightDisplay = false;

    runners: WinGameParticipant[] = [];

    constructor(
        public sitecore: Sitecore,
        private horsesFixtureParticipantHelper: HorsesFixtureParticipantHelper,
    ) {}

    setViewModel(fixture: WinGameFixture): void {
        this.runners = this.horsesFixtureParticipantHelper.getParticipants(fixture.participants);

        this.timeformSpotlightIndexes = [-1, -1, -1];

        for (let i = 0; i < this.runners.length; i++) {
            const runner = this.runners[i];
            if (runner.timeformInfo?.analystRating === 1) {
                this.timeformTipRunner = this.runners[i];
                this.timeformSpotlightIndexes[0] = i;
            }

            if (runner.timeformInfo?.analystRating === 2) {
                this.timeformSpotlightIndexes[1] = i;
            }

            if (runner.timeformInfo?.analystRating === 3) {
                this.timeformSpotlightIndexes[2] = i;
            }
        }

        this.timeformSpotlightDisplay = this.timeformSpotlightIndexes.every((i) => i > -1);
    }
}
